import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import searchIcon from 'images/search_icon.svg';

import { search_page_path } from '../../../routes';

export default function SearchBar({
  isSearchLandingPage,
  scope,
}: {
  isSearchLandingPage: boolean;
  scope: string;
}) {
  const [query, setQuery] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>();

  const handleChange = (e) => setQuery(e.target.value);

  return (
    <div
      className={clsx('tw-mt-20 md:tw-mt-40', {
        'tw-px-16': isSearchLandingPage,
      })}
    >
      <div
        className={clsx({
          'tw-max-w-[600px] tw-mx-auto': isSearchLandingPage,
        })}
      >
        <form id="form_id" action={search_page_path()} method="get" data-id="search-form">
          <div className="tw-flex tw-flex-col tw-gap-16">
            <div className="tw-flex tw-items-center tw-gap-12">
              <img src={searchIcon} width="24" height="24" alt="" />
              <div>
                <h1 className="tw-text-headline-xs tw-font-bold tw-leading-none tw-m-0 tw-p-0">
                  Search The Information
                </h1>
                <p className="tw-text-caption tw-italic tw-m-0">Powered by AI</p>
              </div>
            </div>
            <textarea
              name="query"
              className={clsx(
                // add min-width and max-width classes to prevent horizontal resizing of textarea
                'tw-w-full tw-min-w-full tw-max-w-full tw-min-h-[100px] tw-px-16 tw-py-10 tw-rounded-2',
                'tw-text-body-sm tw-text-grayscale-50 tw-border-gray-300'
              )}
              value={query}
              onChange={handleChange}
              ref={textAreaRef}
            />
            <button
              type="submit"
              className={clsx(
                'tw-text-button-md tw-font-sans !tw-text-white tw-bg-primary-red tw-uppercase tw-border-none',
                'xs:tw-w-[200px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-self-end tw-rounded-2',
                'hover:tw-bg-pro-red focus:tw-bg-pro-red tw-transition-colors'
              )}
            >
              Search
            </button>
          </div>
          <input type="hidden" name="scope" value={scope} />
        </form>
      </div>
    </div>
  );
}
